"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBettingHistory = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useBettingHistory = function (_a) {
    var _b = _a.count, count = _b === void 0 ? 20 : _b;
    var _c = (0, react_1.useState)(count), pageLimit = _c[0], setPageLimit = _c[1];
    var _d = (0, useMutation_1.useMutation)({
        path: keys_1.GET_BETTING_HISTORY,
        successAction: function (data) { },
    }), mutate = _d.mutate, data = _d.data, error = _d.error, isSubmitting = _d.isSubmitting;
    var loadMoreHandler = (0, react_1.useCallback)(function (payload) {
        var limit = pageLimit + count;
        setPageLimit(limit);
        mutate(__assign(__assign({}, payload), { pagination: {
                page: 1,
                limit: limit,
            } }));
    }, [setPageLimit, pageLimit, count, mutate]);
    var loadByFilterHandler = (0, react_1.useCallback)(function (payload) {
        setPageLimit(count);
        mutate(__assign(__assign({}, payload), { pagination: {
                page: 1,
                limit: count,
            } }));
    }, [count, mutate]);
    return (0, react_1.useMemo)(function () { return ({
        data: data,
        loadMore: loadMoreHandler,
        loadMoreByFiler: loadByFilterHandler,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [data, loadMoreHandler, isSubmitting, error, loadByFilterHandler]);
};
exports.useBettingHistory = useBettingHistory;
